export default __webpack_public_path__ + "static/media/heart.ddf1bc49.svg";